import { useEffect, useLayoutEffect, useState } from "react";

import { useDebounce } from "./use-debounce";

export function useWindowSize() {
  const [size, setSize] = useState<{ width: number | null; height: number | null }>({
    width: null,
    height: null,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return size;
}

export const useDebouncedWindowDimensions = () => {
  const [dimensions, setDimensions] = useState<{ width: number; height: number } | null>(null);

  const debouncedDimensions = useDebounce(dimensions, 150);

  useEffect(() => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return debouncedDimensions ?? { width: 0, height: 0 };
};
